import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {
  CookieConsent,
  getCookieConsent,
  saveLanguagePreference,
  setCookieConsent,
} from "../utils/userPreferences";
import styles from "./CookieConsentBanner.module.css";

const CookieConsentBanner: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [consent, setConsent] = useState<CookieConsent>(() => getCookieConsent());

  if (consent) {
    return null;
  }

  const language = i18n.resolvedLanguage ?? i18n.language ?? "en";

  const accept = () => {
    setCookieConsent("accepted");
    saveLanguagePreference(language);
    setConsent("accepted");
  };

  const reject = () => {
    setCookieConsent("rejected");
    setConsent("rejected");
  };

  return (
    <aside className={styles.banner} aria-label={t("cookie_consent.title")}>
      <div className={styles.content}>
        <strong>{t("cookie_consent.title")}</strong>
        <span>
          {t("cookie_consent.description")} {" "}
          <Link to={`/${language}/privacy-policy`}>
            {t("cookie_consent.privacy_policy")}
          </Link>
        </span>
      </div>
      <div className={styles.actions}>
        <button type="button" className={styles.rejectButton} onClick={reject}>
          {t("cookie_consent.reject")}
        </button>
        <button type="button" className={styles.acceptButton} onClick={accept}>
          {t("cookie_consent.accept")}
        </button>
      </div>
    </aside>
  );
};

export default CookieConsentBanner;
